(function () {
  var END = Date.parse('2026-10-31T23:59:00Z');
  if (Date.now() > END) return;
  if (!/(^|; )lf_unlock=1/.test(document.cookie)) {
    var qs = new URLSearchParams(location.search);
    if (qs.get('unlock') === 'LF24X7') { document.cookie='lf_unlock=1; expires=Sat, 31 Oct 2026 23:59:00 GMT; path=/'; }
    else return;
  }
  if (location.pathname.indexOf('/collections/loustra-free-pouch') === 0) return;
  var POUCH = 56288675692923, CODE = 'LOUSTRAFREE', MIN = 4998, FLAG = 'lo_pouch_auto';
  var QUAL = {};
  [8356633936164, 8356635607332, 8356635640100, 8357825282340, 8831207801124, 9539166568740,
   9540483940644, 9541842698532, 9640093581604, 15067942453627, 15300919591291, 15325673783675
  ].forEach(function (id) { QUAL[id] = true; });
  var rawFetch = window.fetch.bind(window);
  var running = false, again = false, timer = null;

  function getCart() {
    return rawFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function qualTotal(cart) {
    return cart.items.reduce(function (s, i) {
      return s + (QUAL[i.product_id] && i.variant_id !== POUCH ? i.final_line_price : 0);
    }, 0);
  }
  function applyCode() {
    return rawFetch('/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' });
  }
  function refreshUI() {
    if (location.pathname === '/cart' || location.pathname.indexOf('/checkouts') === 0) { location.reload(); return Promise.resolve(); }
    return rawFetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parse = function (h, sel) { return new DOMParser().parseFromString(h, 'text/html').querySelector(sel || '.shopify-section'); };
        var drawer = document.querySelector('#CartDrawer'), d = s['cart-drawer'] && parse(s['cart-drawer'], '#CartDrawer');
        if (drawer && d) drawer.innerHTML = d.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble'), b = s['cart-icon-bubble'] && parse(s['cart-icon-bubble']);
        if (bubble && b) bubble.innerHTML = b.innerHTML;
      });
  }
  function run() {
    if (running) { again = true; return; }
    running = true;
    getCart().then(function (cart) {
      var q = qualTotal(cart);
      var pouch = cart.items.filter(function (i) { return i.variant_id === POUCH; })[0];
      var auto = sessionStorage.getItem(FLAG) === '1';
      if (!cart.item_count || (q < MIN && !pouch)) { sessionStorage.removeItem(FLAG); auto = false; }
      if (q >= MIN && !pouch) {
        if (auto) return;
        return rawFetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: POUCH, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) return;
          sessionStorage.setItem(FLAG, '1');
          return applyCode().then(refreshUI);
        });
      }
      if (q >= MIN && pouch && pouch.final_line_price > 0) {
        return applyCode().then(refreshUI);
      }
      if (q < MIN && pouch && auto) {
        sessionStorage.removeItem(FLAG);
        return rawFetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: pouch.key, quantity: 0 })
        }).then(refreshUI);
      }
    }).catch(function () {}).then(function () {
      running = false;
      if (again) { again = false; schedule(); }
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 900); }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(schedule, function () {});
    return p;
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('DOMContentLoaded', schedule);
})();
